export const API_SIGNIN = '/api/oauth2/access_token?grant_type=password&client_id=react2018';
export const API_SIGNOUT= '/api/oauth2/access_token';
export const API_UPDATE_PASSWORD= '/api/password';
export const API_NEW_PORTAL= '/api/newPortal';



// WEBPACK FOOTER //
// ./src/configs/apis.js